module.exports = __webpack_public_path__ + "static/logo-white-70486a2f95c209a30076d6f2876f8aa3.svg";